const init = async () => {
    const btn = document.getElementById('c-product-detail__see-more');
    const text = document.getElementById('c-product-detail__description');
    let isExpanded = false;

    if (btn) {
      btn.addEventListener('click', () => {
        if (!isExpanded) {
          text.classList.add('expanded');
          isExpanded = true;
          btn.innerText = 'See Less';
        } else {
          text.classList.remove('expanded');
          isExpanded = false;
          btn.innerText = 'See More';
        }
      })
    }
};


export default { init };
